export default function Logo({ size = 40, withWordmark = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
      >
        {/* Navy triangular A */}
        <path d="M32 4 L60 60 L48 60 L32 28 L16 60 L4 60 Z" fill="currentColor" className="text-[#0B2545] dark:text-white" />
        {/* Green growth bars */}
        <rect x="30" y="36" width="4" height="20" fill="#16A34A" />
        <rect x="36" y="30" width="4" height="26" fill="#16A34A" />
        <rect x="42" y="24" width="4" height="32" fill="#16A34A" opacity="0.85" />
        {/* Green arc */}
        <path d="M10 38 Q 32 8 56 30" stroke="#16A34A" strokeWidth="3" fill="none" strokeLinecap="round" />
      </svg>
      {withWordmark && (
        <div className="leading-none">
          <div className="font-display font-black text-[15px] tracking-tight">
            <span className="text-[#0B2545] dark:text-white">ADMIN</span>{" "}
            <span className="text-[#16A34A]">APEX</span>
          </div>
          <div className="text-[9px] tracking-[0.25em] text-muted-foreground font-semibold mt-0.5">
            BUSINESS SOLUTIONS
          </div>
        </div>
      )}
    </div>
  );
}
